(function($){

  // -------------------------
  // Thumb window helpers (shared)
  // -------------------------
  var VISIBLE = 6; // window size

  function ensureTrack($thumbs){
    if (!$thumbs.children('.thumb-track').length) {
      $thumbs.wrapInner('<div class="thumb-track"></div>');
    }
    return $thumbs.children('.thumb-track');
  }
  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }
  function calcOffsetPx($track, startIndex){
    var $children = $track.children('.thumb');
    if (!$children.length) return 0;
    var firstRect = $children.eq(0)[0].getBoundingClientRect();
    var startRect = $children.eq(startIndex)[0].getBoundingClientRect();
    return -(startRect.left - firstRect.left);
  }
  function getStart($gallery){ return Number($gallery.data('thumbStart')) || 0; }
  function setStart($gallery, s){ $gallery.data('thumbStart', s); }

  function applyWindow($gallery, startIndex){
    var $thumbs = $gallery.find('.thumbs');
    var $track  = ensureTrack($thumbs);
    var $items  = $track.children('.thumb');
    var maxStart = Math.max(0, $items.length - VISIBLE);
    var s = clamp(startIndex, 0, maxStart);
    var tx = calcOffsetPx($track, s);
    $track.css('transform', 'translateX(' + tx + 'px)');
    setStart($gallery, s);
  }

  // Ensure a given index is visible inside the window; minimal scroll
  function ensureIndexVisible($gallery, index){
    var $thumbs = $gallery.find('.thumbs');
    var $track  = ensureTrack($thumbs);
    var total   = $track.children('.thumb').length;
    if (total <= VISIBLE) return;

    var s = getStart($gallery);
    var leftEdge  = s;
    var rightEdge = s + VISIBLE - 1;

    if (index > rightEdge) {
      s = index - (VISIBLE - 1); // bring to right edge
      applyWindow($gallery, s);
    } else if (index < leftEdge) {
      s = index; // bring to left edge
      applyWindow($gallery, s);
    }
  }

  // -------------------------
  // Main gallery (your block) + integration
  // -------------------------
(function($){
  const TRANSITION_MS = 300;

  function ensureSlidesTrack($gallery){
    const $slidesWrap = $gallery.find('.slides').first();
    if (!$slidesWrap.length) return null;

    let $track = $slidesWrap.children('.slides-track');
    if (!$track.length){
      $slidesWrap.addClass('is-track');

      $track = $('<div class="slides-track"></div>');
      // move any existing media nodes into .slide containers
      $slidesWrap.children(':not(.slides-track)').each(function(){
        const $node = $(this);
        if ($node[0].nodeType !== 1) return; // only element nodes
        const $slide = $('<div class="slide"></div>');
        $node.appendTo($slide);
        $track.append($slide);
      });

      $slidesWrap.empty().append($track);
    }
    const $items = $track.children('.slide');
    return { $wrap: $slidesWrap, $track, $items };
  }

  function setTransform($el, index, withAnim){
    $el.css('transition', withAnim ? `transform ${TRANSITION_MS}ms ease` : 'none')
       .css('transform', `translateX(-${index * 100}%)`);
  }

  $(document).ready(function () {
    $('.bundle_gallery').each(function () {
      const $gallery     = $(this);
      const $bullets     = $gallery.find('.bullets');
      const $thumbsWrap  = $gallery.find('.thumbs');

      ensureTrack($thumbsWrap); // your existing thumbs helper
      const $thumbButtons = $thumbsWrap.find('.thumb');
      const hasThumbs     = $thumbButtons.length > 0;

      // Build sliding layout
      const built = ensureSlidesTrack($gallery);
      if (!built) return;
      const { $wrap, $track, $items } = built;
      const total = $items.length;
      if (!total) return;

      let currentIndex = 0;

      // initial paint (no animation)
      setTransform($track, 0, false);
      applyWindow($gallery, 0); // your existing thumbs window logic

      function showSlide(index){
        if (index < 0) index = (index + total) % total;
        if (index >= total) index = index % total;

        setTransform($track, index, true);

        if (hasThumbs){
          $thumbButtons.removeClass('active').eq(index).addClass('active');
          ensureIndexVisible($gallery, index);
        } else if ($bullets.length){
          $gallery.find('.bullet').removeClass('active').eq(index).addClass('active');
        }

        currentIndex = index;
        $('.bundle_gallery.desktop').trigger('sticky:recalc');
      }

      // Rebuild bullets if needed
      if ($bullets.length && !hasThumbs){
        $bullets.empty();
        for (let i = 0; i < total; i++){
          const $b = $('<span class="bullet"></span>');
          if (i === 0) $b.addClass('active');
          $b.on('click', function(){ showSlide(i); });
          $bullets.append($b);
        }
      }

      // Thumbs click
      if (hasThumbs){
        $thumbButtons.each(function(){
          const i = parseInt($(this).attr('data-index'), 10);
          $(this).on('click', function(){ showSlide(i); });
        });
      }

      // Arrows
      const $prev = $('<button class="arrow prev" aria-label="Previous slide"><span class="gg-chevron-left"></span></button>');
      const $next = $('<button class="arrow next" aria-label="Next slide"><span class="gg-chevron-right"></span></button>');
      const $arrowHost = $gallery.find('.arrows').length ? $gallery.find('.arrows') : $gallery;
      $arrowHost.append($prev, $next);

      $prev.on('click', function(){ showSlide(currentIndex - 1); });
      $next.on('click', function(){ showSlide(currentIndex + 1); });

      // Swipe
      let startX = 0, endX = 0;
      $wrap.on('touchstart', function(e){ startX = e.originalEvent.touches[0].clientX; });
      $wrap.on('touchend',   function(e){
        endX = e.originalEvent.changedTouches[0].clientX;
        if (endX < startX - 30)      showSlide(currentIndex + 1);
        else if (endX > startX + 30) showSlide(currentIndex - 1);
      });

      // Keep current slide on resize + keep thumbs window aligned
      let pending = false;
      $(window).off('resize.thumbsync').on('resize.thumbsync', function(){
        if (pending) return;
        pending = true;
        requestAnimationFrame(function(){
          pending = false;
          setTransform($track, currentIndex, false);
          applyWindow($gallery, getStart($gallery));
        });
      });

      // Thumb edge nudge (unchanged)
      $thumbsWrap.off('click.thumbwin').on('click.thumbwin', 'button.thumb', function(){
        const $btn = $(this);
        const $t = ensureTrack($thumbsWrap);
        const $itemsT = $t.children('.thumb');
        const totalT = $itemsT.length;
        if (totalT <= VISIBLE) return;

        let s = getStart($gallery);
        const idx = $itemsT.index($btn);
        const leftEdge  = s;
        const rightEdge = s + VISIBLE - 1;

        if (idx >= rightEdge - 1 && (s + VISIBLE) < totalT) {
          s += 1;
          applyWindow($gallery, s);
        } else if (idx <= leftEdge + 1 && s > 0) {
          s -= 1;
          applyWindow($gallery, s);
        }
      });

      // expose for external calls
      $gallery.data('showSlide', showSlide);
    });
  });
})(jQuery);

})(jQuery);


// Bundle options

$(document).ready(function () {
  const radios = document.querySelectorAll('.option_box');
  const labels = document.querySelectorAll('.option_label');
  const freeGifts = document.querySelectorAll('.free_gift');

  setTimeout(function () {
      $('#option2').prop('checked', true);
  }, 100);

  function updateUI() {
    // Update checked class
    labels.forEach(label => label.classList.remove('checked'));
    radios.forEach(radio => {
      if (radio.checked) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        label.classList.add('checked');

        // Handle free gifts logic
        if (radio.id === 'option1') {
          freeGifts.forEach(gift => gift.classList.add('available'));
          var radioQant = $('#option1').data('quant');
          var radioDiscountAmount = $('#option1').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').hide();
          $('#freeGift3 .free_gift_inactive').hide();
          $('#freeGift4 .free_gift_inactive').hide();

          $('#freeGift1 .free_gift_active').css('visibility', 'visible');
          $('#freeGift2 .free_gift_active').css('visibility', 'visible');
          $('#freeGift3 .free_gift_active').css('visibility', 'visible');
          $('#freeGift4 .free_gift_active').css('visibility', 'visible');

          $('.last_step_block span').html('Select at least 6 mirrors');


        } else if (radio.id === 'option2') {
          freeGifts.forEach((gift, index) => {
            gift.classList.toggle('available', index === 0 || index === 1 || index === 2);
          });
          var radioQant = $('#option2').data('quant');
          var radioDiscountAmount = $('#option2').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').hide();
          $('#freeGift3 .free_gift_inactive').hide();
          $('#freeGift4 .free_gift_inactive').show();

          $('#freeGift1 .free_gift_active').css('visibility', 'visible');
          $('#freeGift2 .free_gift_active').css('visibility', 'visible');
          $('#freeGift3 .free_gift_active').css('visibility', 'visible');
          $('#freeGift4 .free_gift_active').css('visibility', 'hidden');

          $('.last_step_block span').html('Select at least 3 mirrors');

        } else if (radio.id === 'option3') {
          freeGifts.forEach((gift, index) => {
            gift.classList.toggle('available', index === 0);
          });
          var radioQant = $('#option3').data('quant');
          var radioDiscountAmount = $('#option3').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').show();
          $('#freeGift3 .free_gift_inactive').show();
          $('#freeGift4 .free_gift_inactive').show();
          $('#freeGift5 .free_gift_active').css('visibility', 'visible');
          $('#freeGift2 .free_gift_active').css('visibility', 'hidden');
          $('#freeGift3 .free_gift_active').css('visibility', 'hidden');
          $('#freeGift4 .free_gift_active').css('visibility', 'hidden');

          $('.last_step_block span').html('Select at least 1 mirror');


        }
      }
    });
  }

  radios.forEach(radio => {
    radio.addEventListener('change', updateUI);
  });

  // Initial setup
  updateUI();
});

// Free Gifts Info
$(document).ready(function () {

  $(document).on('click', '.free_gift.available', function () {
    var modalImgURL = $(this).data('alt-img');
    var giftName = $(this).find('.gift_name').text();
    var giftText = $(this).find('.modal_text').val();
    $('.bundle_modal_box h4').text(giftName);
    $('.bundle_modal_box p').text(giftText);
    $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
    $('.bundle_modal').fadeIn();
  });

  $('.bundle_modal_box button').click(function () {
    $('.bundle_modal').hide();
    $('.bundle_modal .modal_add').hide();
  });

  $('.bundle_modal').click(function (e) {
    if (!$(e.target).closest('.bundle_modal_box').length) {
      $(this).hide();
      $('.bundle_modal .modal_add').hide();
    }
  });
  
});

// Variant Items Info
$(document).ready(function () {

  $('.info_button').click(function () {
    var modalImgURL = $(this).data('modal-img');
    var modalTitle = $(this).data('modal-title');
    var modalText = $(this).data('modal-text');
    var modalID = $(this).data('id');
    $('.bundle_modal_box h4').text(modalTitle);
    $('.bundle_modal_box p').text(modalText);
    $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
    $('.bundle_modal_box .modal_add').attr('data-id', modalID);
    $('.bundle_modal .modal_add').show();
    $('.bundle_modal').fadeIn();
  });

  $('.info').click(function () {
    var modalImgURL = $(this).nextAll('.info_button').data('modal-img');
    var modalTitle = $(this).nextAll('.info_button').data('modal-title');
    var modalText = $(this).nextAll('.info_button').data('modal-text');
    var modalID = $(this).nextAll('.info_button').data('id');
    $('.bundle_modal_box h4').text(modalTitle);
    $('.bundle_modal_box p').text(modalText);
    $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
    $('.bundle_modal_box .modal_add').attr('data-id', modalID);
    $('.bundle_modal .modal_add').show();
    $('.bundle_modal').fadeIn();
  });

  info

});

// Bundle Handling

$(document).ready(function () {

  // Update checkout button

  

  function updateCheckoutButton() {
    var parts = [];
    totalQuantity = 0;
  
    for (var id in cartItems) {
      if (cartItems.hasOwnProperty(id)) {
        var qty = cartItems[id];
        totalQuantity += qty;
        parts.push(id + ':' + qty);
      }
    }
  
    var bundleOption = $('input#bundle_option').val();
    var remainingQuantity = bundleOption - totalQuantity;

    var freeGiftItems = null;
    var highestMatch = -1;
    
    $(".free_gift_items").each(function() {
      var minItems = parseInt($(this).data('min-items'), 10);
    
      if (totalQuantity >= minItems && minItems > highestMatch) {
        highestMatch = minItems;
        freeGiftItems = $(this).val();
      }
    });

    console.log(freeGiftItems);

    var cartURL = '/cart/' + parts.join(',') + ',' + freeGiftItems;

    var checkoutButtonText;

    if (remainingQuantity > 1) {
      var checkoutButtonText = 'Select ' + remainingQuantity + ' more mirrors';
    } else {
      if (bundleOption == 1) {
        var checkoutButtonText = 'Select your mirror';
      } else {
        var checkoutButtonText = 'Select your last mirror';
      }
    }

    if ($('input#market').val() === 'CA') {
      cartURL += '?properties=eyJjYW5hZGFfYnVuZGxlIjogInRydWUifQ';
    }

    if (totalQuantity >= bundleOption) {
      $('.checkout_button').removeClass('disabled').attr('href', cartURL).html('Proceed to Checkout <img class="arrow_fix" src="https://cdn.shopify.com/s/files/1/1069/1900/files/lp-right-arrow.svg?v=1711494815">');

      // Update logic later for increased dynamicism
      
      if (totalQuantity >= 6) {
        var bundleAmount = $('input#bundle_1_discount').val();
      } else if (totalQuantity >= 3) {
        var bundleAmount = $('input#bundle_2_discount').val();
      } else if (totalQuantity >= 1) {
        var bundleAmount = $('input#bundle_3_discount').val();
      }
      
      // Debug
      console.log('checkout ready');
    } else {
      $('.checkout_button').addClass('disabled').removeAttr('href').text(checkoutButtonText);

      var bundleAmount = $('input#bundle_discount').val();
      
      // Debug
      console.log('checkout not ready');
    }

    // Update logic later for increased dynamicism

// --- Free-gift unlocks (only after Next Step) ---
let giftsUnlocked = 0;

if ($('body').hasClass('allow_gift_updates')) {
  if (totalQuantity >= 6) {
    giftsUnlocked = 4;
    $('.free_gifts_group_2 #freeGift1 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift1 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift2 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift2 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift3 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift3 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift4 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift4 .free_gift_inactive').hide();
  } else if (totalQuantity >= 3) {
    giftsUnlocked = 3;
    $('.free_gifts_group_2 #freeGift1 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift1 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift2 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift2 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift3 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift3 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift4 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift4 .free_gift_inactive').show();
  } else if (totalQuantity >= 1) {
    giftsUnlocked = 1;
    $('.free_gifts_group_2 #freeGift1 .free_gift_active').css('visibility', 'visible');
    $('.free_gifts_group_2 #freeGift1 .free_gift_inactive').hide();

    $('.free_gifts_group_2 #freeGift2 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift2 .free_gift_inactive').show();

    $('.free_gifts_group_2 #freeGift3 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift3 .free_gift_inactive').show();

    $('.free_gifts_group_2 #freeGift4 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift4 .free_gift_inactive').show();
  } else {
    giftsUnlocked = 0;
    $('.free_gifts_group_2 #freeGift1 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift1 .free_gift_inactive').show();

    $('.free_gifts_group_2 #freeGift2 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift2 .free_gift_inactive').show();

    $('.free_gifts_group_2 #freeGift3 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift3 .free_gift_inactive').show();

    $('.free_gifts_group_2 #freeGift4 .free_gift_active').css('visibility', 'hidden');
    $('.free_gifts_group_2 #freeGift4 .free_gift_inactive').show();
  }
}

    
    let totalFreebiePrice = 0;
  
    $('.free_gift.available').each(function() {
      const price = parseFloat($(this).data('price'));
      if (!isNaN(price)) {
        totalFreebiePrice += price;
      }
    });

    var totalSavingsNoGifts = bundleAmount * totalQuantity;
    var totalSavings = Math.floor((totalSavingsNoGifts + totalFreebiePrice) * 100) / 100;

    $('span#gifts_unlocked span').html(giftsUnlocked);
    $('span#total_savings span').html(totalSavings);

    // Debug
    console.log('totalQuantity:', totalQuantity);
    console.log('Bundle option:' + bundleOption);
    console.log('Bundle amount:' + bundleAmount);
    console.log('Items price total:' + totalSavingsNoGifts);
    console.log('Freebie price total:' + totalFreebiePrice);
    console.log('Total Savings:' + totalSavings);
    console.log('Gifts Unlocked:' + giftsUnlocked);
    
  }

  function updatePrevStepButton() {
    var bundleNumber = $('input#bundle_option').val();
    if (bundleNumber > 1) {
      $('.prev_step span').text('Select at least ' + bundleNumber + ' mirrors');
    } else {
      $('.prev_step span').text('Select at least 1 mirror');
    }
    console.log(bundleNumber);
  }

  // Step toggle
  
  $('.next_step button').click(function () {
    $('body').addClass('second_step_active');
    setTimeout(function () {
      $('body').addClass('allow_gift_updates');
    }, 500);
    $('.bunde-lp-section').hide();
    $('#lp_topbar_2').show();
    $('.checkout_button_wrapper').css({
      visibility: 'visible',
      height: 'auto'
    });
    updatePrevStepButton();
    setTimeout(function () {
        updateCheckoutButton();
    }, 100);
    $('.guarantee_block').show();
    $('.bundle_gallery.mobile').hide();
  });
  
  $('.sticky_button button').click(function () {
    $('body').addClass('second_step_active');
    setTimeout(function () {
      $('body').addClass('allow_gift_updates');
    }, 500);
    $('.bunde-lp-section').hide();
    $('#lp_topbar_2').show();
    $('.checkout_button_wrapper').css({
      visibility: 'visible',
      height: 'auto'
    });
    updatePrevStepButton();
    setTimeout(function () {
        updateCheckoutButton();
    }, 100);
    $('.guarantee_block').show();
    $('.bundle_gallery.mobile').hide();
  });
  
  $('.prev_step button').click(function () {
    $('body').removeClass('second_step_active');
    $('.bunde-lp-section').show();
    $('#lp_topbar_2').hide();
    $('.checkout_button_wrapper').css({
      visibility: 'hidden',
      height: '0'
    });
  });
  
  $('.last_step_block button').click(function () {
    $('body').removeClass('second_step_active');
    $('.bunde-lp-section').show();
    $('#lp_topbar_2').hide();
    $('.checkout_button_wrapper').css({
      visibility: 'hidden',
      height: '0'
    });
    $('.guarantee_block').hide();
    $('.bundle_gallery.mobile').show();
  });

  // Add variants

  var cartItems = {};
  
  // Show the quantity selector on Add button click
  $('.quant_selectors .add').click(function () {
    
    const $container = $(this).closest('.quant_selectors');
    const variantId = $container.data('id');

    $(this).hide();
    $container.find('.quantity-selector').show();
    $container.find('.quantity-input').val(1);

    cartItems[variantId] = 1;
    updateCheckoutButton();
  });

  // Increase quantity
  $('.quant_selectors .increase').click(function () {
    const $container = $(this).closest('.quant_selectors');
    const $input = $container.find('.quantity-input');
    const variantId = $container.data('id');

    let current = parseInt($input.val(), 10);
    current += 1;
    $input.val(current);

    cartItems[variantId] = current;
    updateCheckoutButton();
  });

  // Decrease quantity
  $('.quant_selectors .decrease').click(function () {
    const $container = $(this).closest('.quant_selectors');
    const $input = $container.find('.quantity-input');
    const variantId = $container.data('id');

    let current = parseInt($input.val(), 10);
    current -= 1;

    if (current <= 0) {
      $input.val(0);
      $container.find('.quantity-selector').hide();
      $container.find('.add').show();
      delete cartItems[variantId];
    } else {
      $input.val(current);
      cartItems[variantId] = current;
    }

    updateCheckoutButton();
  });

  // Handle modal 'Add' button
  
  $('.modal_add').click(function () {
    const variantId = $(this).data('id');
  
    // Show quantity selector on all matching .quant_selectors
    const $matchingSelectors = $('.quant_selectors').filter(function () {
      return $(this).data('id') == variantId;
    });
  
    $matchingSelectors.each(function () {
      $(this).find('.quantity-selector').show();
      $(this).find('.quantity-input').val(1);
    });
  
    cartItems[variantId] = 1;
    updateCheckoutButton();

    $(".quant_selectors").each(function() {
        if ($(this).data('id') == variantId) {
          $(this).find('.add').hide();
        }
    });
  });

});

// Free Gifts Date Widget

$(document).ready(function() {
    var today = new Date();
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var formattedDate = months[today.getMonth()] + " " + today.getDate();
    $(".free_gifts_date span").text(formattedDate);
});

$(document).ready(function() {
    $(window).on('scroll', function() {
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();
        var scrollTop = $(window).scrollTop();

        var bottomScrollPosition = scrollTop + windowHeight;
        var scrollFromBottom = documentHeight - bottomScrollPosition;

        var topDistance1 = $('.bundle_left').height();
        var topDistance2 = $('#step_height_2').height();
        var topDistanceTotal = topDistance1 + topDistance2;

        var topThreshold = topDistanceTotal + 100;
        var bottomThreshold = 350;

        if (scrollTop > topThreshold && scrollFromBottom > bottomThreshold) {
            $('.sticky_button').show();
        } else {
            $('.sticky_button').hide();
        }
        if (scrollTop > 15) {
            $('.show_sticky').show();
        }
    });
    $('.sticky_button .select_bundle').on('click', function(e){
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 51
      }, 600);
    });


});

// Handle gallery change between steps

jQuery(function($) {
  var $el = $('.second_step_left');
  if (!$el.length) return;

  var THRESHOLD = 122;
  var TOP_TOLERANCE = 5;
  var isFixed = false;
  var armed = false;
  var originalStyleAttr = $el.attr('style') || '';

  function elementIsVisible() {
    return $el.length && $el.is(':visible') && $el.outerHeight() > 0 && $el.outerWidth() > 0;
  }

  function applyFixedBox() {
    var $p = $el.parent();
    var left = $p.offset() ? $p.offset().left : $el.offset().left;

    // Keep only position + top + left. Let CSS handle width.
    $el.css({
      position: 'fixed',
      top: 0,
      left: left
    });
  }

  function fixNow() {
    if (isFixed) return;
    isFixed = true;
    applyFixedBox();
  }

  function unfixNow() {
    if (!isFixed) return;
    isFixed = false;
    if (originalStyleAttr) $el.attr('style', originalStyleAttr);
    else $el.removeAttr('style');
  }

  function maybeArmAtTop() {
    var atTop = $(window).scrollTop() <= TOP_TOLERANCE;
    if (!armed && atTop && elementIsVisible()) {
      armed = true;
    }
  }

  function onScroll() {
    maybeArmAtTop();
    if (!armed) return;
    if ($(window).scrollTop() >= THRESHOLD) fixNow();
    else unfixNow();
  }

  $(window).on('scroll', onScroll);
  $(window).on('resize orientationchange', function() {
    if (isFixed) applyFixedBox();
  });

  maybeArmAtTop();
  onScroll();
});



//Change variant title case

jQuery(function($){
  $('.variant-title').each(function(){
    var text = $(this).text().toLowerCase();
    text = text.replace(/\b\w/g, function(match){
      return match.toUpperCase();
    });
    $(this).text(text);
  });
});


// Hide Checkout Button on mobile until the user gets to the bottom

/*

jQuery(function($) {
  var $el = $('.checkout_button_wrapper');
  if (!$el.length) return;

  function toggleButton() {
    var winW = $(window).width();
    if (winW >= 768) {
      $el.show(); // Always visible on desktop
      return;
    }

    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var documentHeight = $(document).height();
    var distanceFromBottom = documentHeight - (scrollTop + windowHeight);

    if (distanceFromBottom <= 400) {
      $el.fadeIn(200);
    } else {
      $el.fadeOut(200);
    }
  }

  $(window).on('scroll resize orientationchange', toggleButton);
  toggleButton(); // run once on load
});

*/

// Handle tabs

jQuery(function($) {
  $('.upper_tabs').on('click', 'div h3', function() {
    var $h3 = $(this);
    var $content = $h3.next('p, ul');

    if (!$content.length) return;

    if ($content.is(':visible')) {
      $content.slideUp(200);
      $h3.removeClass('tab_active');
    } else {
      $content.slideDown(200);
      $h3.addClass('tab_active');
    }
  });
});
